import { render, staticRenderFns } from "./C-2-2__SubCategoryEdit.vue?vue&type=template&id=5a314f35&"
import script from "./C-2-2__SubCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./C-2-2__SubCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VSpacer})
